import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * "Back" for standalone pages (pricing, contact). Returns to wherever the
 * visitor came from: an in-app screen (router history), or a same-origin
 * page that linked here with a full page load (the public landing, the
 * settings dialog). Only a page opened directly falls back to `fallback`.
 */
export function usePageBack(fallback: string): () => void {
  const navigate = useNavigate();
  const { key } = useLocation();
  return useCallback(() => {
    // react-router gives the first entry of a session the key "default".
    if (key !== 'default') { navigate(-1); return; }
    let cameFromThisSite = false;
    try { cameFromThisSite = new URL(document.referrer).origin === window.location.origin; } catch { /* no referrer */ }
    if (cameFromThisSite && window.history.length > 1) { window.history.back(); return; }
    navigate(fallback, { replace: true });
  }, [fallback, key, navigate]);
}
